import { render } from "./CatMotivosRechazoView.vue?vue&type=template&id=50b69abc&scoped=true"
import script from "./CatMotivosRechazoView.vue?vue&type=script&lang=js"
export * from "./CatMotivosRechazoView.vue?vue&type=script&lang=js"

import "./CatMotivosRechazoView.vue?vue&type=style&index=0&id=50b69abc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b69abc"]])

export default __exports__